<template>
  <div class="pb-16 w-full pt-12 lg:pt-28">
    <article class="prose max-w-none">
      <router-view></router-view>
    </article>
  </div>
</template>
